var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pipeline-stepper" }, [
    _c(
      "div",
      { staticClass: "pipeline-stepper__pipeline" },
      _vm._l(_vm.stepsToDisplay, function(step, index) {
        return _c("PipelineStep", {
          key: index,
          attrs: {
            step: step,
            selected: _vm.selectedStepId === step.id,
            finished: _vm.isFinished(step),
            isFirst: index === 0,
            isLast: index === _vm.stepsToDisplay.length - 1,
            canEdit: _vm.canEdit
          },
          on: { update: _vm.handleUpdate }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }